import React, { Component } from "react";
import PropTypes from "prop-types";
import Layout from "../Layout";
import { Layout13 } from "../ContentBox";
import { DivHover, DivHelp } from "./styled";

class DealGroupView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
    };
  }
  onHover = () => {
    this.setState({ hover: true });
  };
  onMouseOver = () => {
    this.setState({ hover: false });
  };
  render() {
    return (
      <DivHover
        onMouseLeave={this.onMouseOver.bind(this)}
        onMouseEnter={this.onHover.bind(this)}
      >
        <Layout {...this.props} type="DealGroupView" />
        {this.state.hover && <DivHelp>Content</DivHelp>}
      </DivHover>
    );
  }
}

DealGroupView.propTypes = {
  childOf: PropTypes.string,
  values: PropTypes.object,
  cell: PropTypes.array,
  layout: PropTypes.func,
};

DealGroupView.defaultProps = {
  childOf: "Content",
  values: {
    parent: "Content",
    type: "DealGroupView",
    list: [
      {
        href: {
          url: "",
          target: "",
          isCollection: false,
          collection: 0,
        },
        imageUrl: {
          url: "",
          urlMobile: "",
          desktop: {
            width: 0,
            height: 0,
          },
          mobile: {
            width: 0,
            height: 0,
          },
        },
        title: "Title",
        titleDiscount: "Save up to",
        discount: 0,
      },
    ],
    typeContent: "custom",
    listProduct: [],
    columnDesktop: 3,
    showPrice: true,
    showDiscount: false,
    header: "Header",
    alignHeader: "center",
    containerPadding: "0px",
    visibleHeader: true,
  },
  layout: Layout13,
};
export default DealGroupView;



// WEBPACK FOOTER //
// ./src/editor/layout/components/Content/DealGroupView.js